<div class="svg-editor-container">
  <div class="svg-editor-field" *ngIf="formControl">
    <mat-form-field>
      <mat-label>{{ label | translate }}</mat-label>
      <textarea
        matInput
        [placeholder]="placeholder | translate"
        [formControl]="formControl"
      ></textarea>
      <mat-error *ngIf="!disabledValidation">
        <wlm-validation-messages
          [addMarginBottom]="false"
          [control]="formControl"
        ></wlm-validation-messages>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="svg-editor-preview-container">
    <h4 class="svg-editor-preview-title">{{ previewLabel | translate }}</h4>
    <div class="svg-editor-preview">
      <p *ngIf="!previewValue">{{ previewPlaceholder | translate }}</p>
      <div #svgContent></div>
    </div>
  </div>
</div>
